import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home-main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommunicationContainer = _resolveComponent("CommunicationContainer")!
  const _component_RecordsContainer = _resolveComponent("RecordsContainer")!
  const _component_OthersContainer = _resolveComponent("OthersContainer")!
  const _component_MemoruTopContainer = _resolveComponent("MemoruTopContainer")!
  const _component_SettingContainer = _resolveComponent("SettingContainer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.tabIndex === 'message')
          ? (_openBlock(), _createBlock(_component_CommunicationContainer, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.tabIndex === 'record')
          ? (_openBlock(), _createBlock(_component_RecordsContainer, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.tabIndex === 'other')
          ? (_openBlock(), _createBlock(_component_OthersContainer, {
              key: 2,
              "active-diary": _ctx.activeDiary ?? undefined,
              "onUpdate:activeDiary": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeDiary = $event))
            }, null, 8, ["active-diary"]))
          : _createCommentVNode("", true),
        (_ctx.tabIndex === 'memoru')
          ? (_openBlock(), _createBlock(_component_MemoruTopContainer, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.tabIndex === 'setting')
          ? (_openBlock(), _createBlock(_component_SettingContainer, { key: 4 }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_bottom_navigation, {
        app: "",
        grow: "",
        modelValue: _ctx.tabIndex,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabIndex) = $event)),
        color: "primary",
        mandatory: ""
      }, {
        default: _withCtx(() => [
          (_ctx.shouldShowMessage)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                value: "message",
                style: {"height":"auto","min-width":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-message-text", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tabBar.communication')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.shouldShowRecord)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                value: "record",
                style: {"height":"auto","min-width":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-pencil", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tabBar.record')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.shouldShowOther)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                value: "other",
                style: {"height":"auto","min-width":"0"},
                onClick: _ctx.handleOtherClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-dots-horizontal", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tabBar.other')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.shouldShowSettings)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 3,
                value: "setting",
                style: {"height":"auto","min-width":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-cog", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tabBar.settings')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}